import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Vize danışmanları ne kadar ücret alıyor?',
      answer: 'Danışmanlık ücretleri vize türüne ve hizmet kapsamına göre değişiklik gösterir. Başvurulan ülke, vize türü ve evrak kapsamına göre fiyatlandırma yapılmaktadır. Şeffaf ve net fiyat politikamız ile gizli ücret bulunmamaktadır. Detaylı bilgi için bizimle iletişime geçebilirsiniz.',
    },
    {
      question: 'En kolay vize nereden alınır?',
      answer: 'Kişisel profil, seyahat geçmişi ve evrak yapısına göre değişir. Her başvuru sahibinin durumu farklıdır. Uzman danışmanlarımız profilinizi değerlendirerek size en uygun vize türünü ve ülkeyi önerir. E-vizeler genellikle daha hızlı işlem görmektedir.',
    },
    {
      question: 'Vize için hesapta kaç TL olması lazım?',
      answer: 'Ülkeye ve seyahat süresine bağlı olarak günlük minimum bakiye talep edilir. Her ülkenin farklı finansal belge gereksinimleri vardır. Schengen ülkeleri için genellikle günlük 50-70 Euro arası bakiye beklenir. Detaylı bilgi için danışmanlarımızla görüşebilirsiniz.',
    },
    {
      question: 'Vize reddi alırsam tekrar başvuru yapabilir miyim?',
      answer: 'Evet. Ret nedenleri analiz edilerek yeniden başvuru yapılabilir. Uzman ekibimiz ret nedenlerini detaylı şekilde değerlendirerek yeni başvurunuzu güçlendirir ve eksiklikleri tamamlar. Ret sonrası doğru strateji ile başvuru başarı oranı artırılabilir.',
    },
    {
      question: 'İzmir Vize Danışmanlık süreciniz nasıl işler?',
      answer: 'Sürecimiz 4 adımdan oluşur: 1) Ön Değerlendirme - Seyahat amacı ve profil analizi, 2) Evrak Planlaması - Gerekli belgeler detaylı belirlenir, 3) Profesyonel Evrak Kontrolü - Eksik ve riskli noktalar tespit edilir, 4) Randevu ve Başvuru Yönetimi - Konsolosluk süreçleri yürütülür ve sonuçlanana kadar takip edilir.',
    },
    {
      question: 'Yunanistan Kosmos Vize başvurusu nasıl yapılır?',
      answer: 'Yunanistan Schengen vize başvuruları İzmir\'de Kosmos Vize üzerinden yürütülmektedir. Randevu alma, evrak hazırlığı ve başvuru süreci detaylıdır. Danışmanlarımız Kosmos Vize prosedürlerine uygun şekilde başvurunuzu hazırlar ve süreci sizin adınıza takip eder.',
    },
    {
      question: 'İade garantiniz nasıl çalışır?',
      answer: 'İade garantili danışmanlık modelimizde, belirli koşullar altında vize reddedilirse danışmanlık ücretiniz iade edilir. Garanti koşulları başvuru öncesi detaylı olarak açıklanır ve sözleşmeye bağlanır. 10+ yıllık deneyimimiz ve yüksek onay oranımız sayesinde müşterilerimize güvence sağlıyoruz.',
    },
    {
      question: 'Hangi ülkelere vize hizmeti veriyorsunuz?',
      answer: 'İspanya, Fransa, İngiltere, Yunanistan, Hollanda, İtalya, Bulgaristan, Almanya gibi Schengen ülkeleri, Amerika, İngiltere ve 25+ ülkeye vize danışmanlığı hizmeti sunuyoruz. Ayrıca Dubai, Ermenistan, Kuveyt, Suudi Arabistan, Rusya, Vietnam, Küba için e-vize hizmetlerimiz bulunmaktadır.',
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-white to-cream-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-4 py-1.5 md:px-5 md:py-2 bg-navy-900 text-cream-100 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-5 shadow-lg">
            SSS
          </span>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-3 md:mb-4">
            Sıkça Sorulan Sorular
          </h2>
          <p className="text-navy-700 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed">
            İzmir vize danışmanlığı hizmetlerimiz hakkında merak ettikleriniz
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl md:rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-5 py-4 md:px-7 md:py-5 flex items-center justify-between text-left hover:bg-cream-50 transition-colors cursor-pointer"
              >
                <h3 className="font-display text-sm md:text-lg font-bold text-navy-900 pr-3">
                  {faq.question}
                </h3>
                <div
                  className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-navy-900 rounded-full flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-lg md:text-2xl text-cream-100"></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 pb-4 md:px-7 md:pb-5">
                  <p className="text-navy-600 leading-relaxed text-xs md:text-sm">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-8 md:mt-10 text-center">
          <p className="text-navy-700 text-sm md:text-base mb-4 md:mb-5">
            Başka sorularınız mı var? Hemen bizimle iletişime geçin!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-3">
            <a
              href="https://wa.me/905514803007?text=Merhaba%20ben%20sizinle%20karsiyakavisaconsulting.com.tr%20sitesinden%20iletisime%20geciyorum"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-5 py-2.5 md:px-7 md:py-3 bg-green-600 text-white rounded-full font-bold text-sm md:text-base hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill text-lg md:text-xl mr-2"></i>
              WhatsApp ile Sor
            </a>
            <a
              href="tel:+905514803007"
              className="inline-flex items-center px-5 py-2.5 md:px-7 md:py-3 bg-navy-900 text-cream-100 rounded-full font-bold text-sm md:text-base hover:bg-navy-800 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-lg md:text-xl mr-2"></i>
              Hemen Ara
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;